import { render, staticRenderFns } from "./POIs.vue?vue&type=template&id=a3c16822&scoped=true&"
import script from "./POIs.vue?vue&type=script&lang=js&"
export * from "./POIs.vue?vue&type=script&lang=js&"
import style0 from "./POIs.vue?vue&type=style&index=0&id=a3c16822&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c16822",
  null
  
)

export default component.exports